import { default as config } from "common/config/config";
import { useEffect, useRef, useState } from "react";
import { authService } from "features/auth/services/authService";
import useTranslate from "ui/locale/hooks/useTranslate";

const OrchestratorPage = (): JSX.Element => {
    const translate = useTranslate();
    const [loading, setLoading] = useState(true);
    const [orchestratorUrl, setOrchestratorUrl] = useState("");
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        let isMounted = true;

        const loadOrchestrator = async () => { // skipcq: JS-0116
            try {
                setLoading(true);

                const origin = "pideky-admin";
                const url = `${config.orchestratorFrontUrl}/?origin=${origin}`;

                if (isMounted) {
                    setOrchestratorUrl(url);
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error al cargar orchestrator o obtener tokens:", error);
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        loadOrchestrator();

        return () => {
            isMounted = false;
        };
    }, []);

    const handleIframeLoad = () => {
        const iframe = iframeRef.current;
        if (!iframe) return;
        authService
            .getSessionTokens()
            .then((tokens) => {
                if (tokens?.accessToken) {
                    const message = {
                        type: "AUTH_TOKENS",
                        accessToken: tokens.accessToken.toString(),
                        idToken: tokens.idToken?.toString() || null,
                    };

                    const targetOrigin = new URL(config.orchestratorFrontUrl).origin;
                    setTimeout(() => {
                        iframe.contentWindow?.postMessage(message, targetOrigin);
                    }, 7000);
                }
            })
            .catch((err) => {
                console.error("Error al obtener tokens para postMessage:", err);
            });
    };

    // skipcq: JS-D010 - Se requiere allow-scripts y allow-same-origin para funcionalidad crítica
    return !loading ? (
        // skipcq: JS-D010
        <iframe
            ref={iframeRef}
            src={orchestratorUrl}
            style={{
                width: "100%",
                height: "calc(100vh - 120px)",
                border: "none",
                overflow: "hidden",
            }}
            title={translate("orchestrator")}
            allowFullScreen
            sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-downloads"
            onLoad={handleIframeLoad}
        />
    ) : (
        <div></div>
    );
};

export default OrchestratorPage;
